import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./PersonalInfoContainer.module.scss";
import config from "@Config/index";
import EnglishPersonalInfo from "./EnglishPersonalInfo";
import ChinesePersonalInfo from "./ChinesePersonalInfo";

const PersonalInfoContainer = () => (
  <div className={styles.mainContainer}>
    {config.IS_CHINA_APP ? <ChinesePersonalInfo /> : <EnglishPersonalInfo />}
  </div>
);

export default wrapperHOC(PersonalInfoContainer, {
  componentName: "PersonalInfoContainer",
  showForChina: true,
});
